import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type LinkContentFragment = { __typename?: 'NotificationGroupContent', link: { __typename?: 'NotificationLinkAccessRequestAsset', project: { __typename?: 'NotificationLinkResource', id: string } } | { __typename?: 'NotificationLinkAccessRequestCollection', project: { __typename?: 'NotificationLinkResource', id: string } } | { __typename?: 'NotificationLinkAccessRequestFolder', project: { __typename?: 'NotificationLinkResource', id: string } } | { __typename?: 'NotificationLinkAccessRequestProject', project: { __typename?: 'NotificationLinkResource', id: string } } | { __typename?: 'NotificationLinkAsset', asset: { __typename?: 'NotificationLinkResource', id: string }, project: { __typename?: 'NotificationLinkResource', id: string }, version?: { __typename?: 'NotificationLinkResource', id: string } | null } | { __typename?: 'NotificationLinkComment', asset: { __typename?: 'NotificationLinkResource', id: string }, comment: { __typename?: 'NotificationLinkResource', id: string }, project: { __typename?: 'NotificationLinkResource', id: string }, version?: { __typename?: 'NotificationLinkResource', id: string } | null } | { __typename?: 'NotificationLinkCommentViaShare', share: { __typename?: 'NotificationLinkResource', id: string }, asset: { __typename?: 'NotificationLinkResource', id: string }, comment: { __typename?: 'NotificationLinkResource', id: string }, version?: { __typename?: 'NotificationLinkResource', id: string } | null } | { __typename?: 'NotificationLinkFolder', folder?: { __typename?: 'NotificationLinkResource', id: string } | null, project: { __typename?: 'NotificationLinkResource', id: string } } };

export const LinkContent = /*#__PURE__*/ gql`
    fragment LinkContent on NotificationGroupContent {
  link {
    ... on NotificationLinkAsset {
      asset {
        id
      }
      project {
        id
      }
      version {
        id
      }
    }
    ... on NotificationLinkComment {
      asset {
        id
      }
      comment {
        id
      }
      project {
        id
      }
      version {
        id
      }
    }
    ... on NotificationLinkFolder {
      folder {
        id
      }
      project {
        id
      }
    }
    ... on NotificationLinkAccessRequestAsset {
      project {
        id
      }
    }
    ... on NotificationLinkAccessRequestFolder {
      project {
        id
      }
    }
    ... on NotificationLinkAccessRequestProject {
      project {
        id
      }
    }
    ... on NotificationLinkAccessRequestCollection {
      project {
        id
      }
    }
    ... on NotificationLinkCommentViaShare {
      share {
        id
      }
      asset {
        id
      }
      comment {
        id
      }
      version {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<LinkContentFragment, unknown>;

        

        
export const useLinkContentFragment = (
  input: string | Omit<UseFragmentOptions<LinkContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroupContent' } };
    return input;
  })();

  return useFragment<LinkContentFragment>({
    fragment: LinkContent,
    fragmentName: 'LinkContent',
    ...options,
  });
};
  
        